<template>
    <div class="datastatistics">
        <!-- 右上角学习人次统计 -->
        <div style="position: absolute; top: 20px; right: 20px; background: #f5f7fa; border: 1px solid #e4e7ed; padding: 12px 20px; border-radius: 4px; white-space: nowrap; cursor: pointer;" @click="goToLearningChart('study_times')">
          <span style="font-size: 14px; color: #606266;">筛选时间段内总学习人次:<span v-loading="loading" style="color: #409eff;">{{ formatNumber(lastWeekLearningCount) }} </span>
          </span>
        </div>
      <!-- 新增：总学习人数统计区域 -->
      <div style="position: absolute; top: 20px; right: 260px; background: #f5f7fa; border: 1px solid #e4e7ed; padding: 12px 20px; border-radius: 4px; white-space: nowrap; cursor: pointer;" @click="goToLearningChart('study_users')">
      <span style="font-size: 14px; color: #606266;">筛选时间段内总学习人数:<span v-loading="loading" style="color: #409eff;">{{ formatNumber(lastWeekUserNum) }} </span>
      </span>
      </div>
        <el-row style="display: flex; align-items: center; margin-bottom: 10px;">
            <div style="margin-left: 20px;">学习数据统计（{{ total }}）</div>
            <el-input v-model="query.title" placeholder="请输入标题" size="mini" maxlength="30"></el-input>
            <el-input v-model="query.period_id" placeholder="请输入课节ID" size="mini" maxlength="10" @input="handleInput"></el-input>

          <el-date-picker
              v-model="query.start_end_time"
              size="small"
              value-format="yy-MM-dd HH:mm:ss"
              type="datetimerange"
              align="right"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
            <el-button size="mini" type="primary" @click="getList">搜索</el-button>
        </el-row>
        <el-row style="margin-top: 35px">
            <el-table :data="tableData" style="width: 100%" v-loading="loading" border>
                <el-table-column prop="id" label="ID"  align="center" min-width="4%"></el-table-column>
                <el-table-column prop="status" label="状态" align="center" min-width="4%">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.status==1?'已发布':'未发布' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="type" label="类型" align="center" min-width="5%">
                    <template slot-scope="scope">
                        <div v-if="scope.row.type !=4">
                            {{ scope.row.type==1?'音频':scope.row.type==2?'视频':'图文' }}
                        </div>
                        <div v-else>
                            {{ scope.row.live_type==1?'普通直播':scope.row.live_type==2?'互动直播':scope.row.live_type==3?'语音图片直播'
                            :scope.row.live_type==4?'推流直播':scope.row.live_type==6?'伪直播':'小鹅通直播' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="title" label="标题" align="center" min-width="12%">
 
                </el-table-column>
                <el-table-column prop="duration" label="时长" align="center" min-width="5%">
                </el-table-column>
                <el-table-column prop="file_size" label="文件大小" align="center" min-width="5%"></el-table-column>
                <el-table-column prop="is_free" label="试听" align="center" min-width="5%">
                    <template slot-scope="scope">
                        <div>
                            {{ scope.row.is_free==1?'允许':'不允许' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="free_duration" label="试听时长" align="center" min-width="5%"></el-table-column>
                <el-table-column prop="sort" label="排序" align="center" min-width="4%"></el-table-column>
                <el-table-column prop="created_at" label="创建时间" align="center" min-width="8%"></el-table-column>
                <el-table-column prop="released_at" label="发布时间" align="center" min-width="8%"></el-table-column>
                <el-table-column prop="study_number" label="学习人数" align="center" min-width="8%"></el-table-column>
                <el-table-column prop="study_num" label="到课人数" align="center" min-width="5%">
                    <template slot-scope="scope">
                        <div style="color: #409eff; cursor: pointer;" @click="$router.push(`/datastatistics/arrivelist?id=${scope.row.id}`)">
                         {{ scope.row.study_num }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="begin_at" label="直播开始时间" align="center" min-width="8%"></el-table-column>
                <el-table-column prop="study_user_nums" label="学习人数（新）" align="center" min-width="9%">
                    <template slot-scope="scope">
                        <div style="color: #409EFF; cursor: pointer;" @click="goToStudyDurationChart(scope.row.id)">
                            {{ scope.row.study_user_nums }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="study_times" label="学习人次" align="center" min-width="8%"></el-table-column>
            </el-table>
        </el-row>
        <el-row>
            <div class="block">
                <el-pagination
                    background 
                    @current-change="getList" 
                    @size-change="handleSizeChange"
                    :current-page.sync="query.page" 
                    :page-sizes="[ 10,20, 30, 40, 50]"
                    :page-size="query.limit"
                    layout="total,sizes, prev, pager, next, jumper" 
                    :total="total">
                </el-pagination>
            </div>
        </el-row>
    </div>
</template>

<script>
import { getStudyData } from "@/api/datastatistics";
export default {
    name: "",
    data() {
        return {
            query: {
                course_id: this.$route.query.course_id,
                title: "",
                period_id: '',
                start_end_time: [],
                limit: 10,
                page: 1,
            },
            loading: false,
            total:0,
            tableData:[],
            // 上周总学习人次
            lastWeekLearningCount: 0,
            lastWeekUserNum: 0,
            dashboardFilterForm: {
            dateRange: []
          },
        };
    },
    mounted() {
        // 设置默认日期为当天
        const today = new Date();
        const startOfDay = new Date(today);
        startOfDay.setHours(0, 0, 0, 0);
        const endOfDay = new Date(today);
        endOfDay.setHours(23, 59, 59, 999);
        
        // 格式化日期为组件需要的格式
        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        };
        
        this.query.start_end_time = [formatDate(startOfDay), formatDate(endOfDay)];
        this.getList();
    },
    methods: {
        getList() {
          this.loading = true;
            getStudyData(this.query).then((res) => {
                if(res.code == 1){
                    this.tableData = res.data.list
                    this.total = res.data.total
                    this.loading = false
                    this.lastWeekLearningCount = res.data.last_week_num
                    this.lastWeekUserNum = res.data.last_week_user_num
                    // console.log(this.tableData[0].study_num);
                }
            });
        },
        handleInput(value) {
            const filteredValue = value.replace(/\D/g, '');
            // 更新数据
            this.query.period_id = filteredValue;
        },
        formatNumber(num) {
            if (num === null || num === undefined) return '0';
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
    handleSizeChange(val) {
        this.query.limit = val;
        this.getList();
      },
      goToLearningChart(type) {
        // 跳转到学习统计曲线图页面，并传递时间范围参数
        this.$router.push({
          path: '/datastatistics/learningchart',
          query: {
            type: type,
            course_id: this.query.course_id,
            start_end_time: JSON.stringify(this.query.start_end_time)
          }
        });
      },
      goToStudyDurationChart(periodId) {
        // 跳转到学习时长统计图表页面
        this.$router.push({
          path: '/datastatistics/studydurationchart',
          query: {
            period_id: periodId,
            start_end_time: JSON.stringify(this.query.start_end_time)
          }
        });
      },
    },
};
</script>

<style>
.datastatistics .el-input{
    width: 150px;
    margin-right: 30px;
}
.datastatistics .block .el-input{
    width: 60px;
}
.datastatistics .el-table td, .el-table th{
    padding: 8px 0;
}
</style>